import styled from "styled-components";

export const Container = styled.div`
  width: ${(props) => props.width || "340px"};
  height: ${(props) => props.height || "116px"};
  border-radius: 2px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;
  margin-bottom: 20px;
  @media (max-width:1440px) {
    width: ${(props) => props.width1440 || "280px"};
  }
  @media (max-width: 1312px) {
    width: ${(props) => props.width1312 || "260px"};
  }
  @media (max-width: 1150px) {
    width: ${(props) => props.width1150 || "230px"};
  }

  @media (max-width: 1024px) {
    width: ${(props) => props.width600 || "264px"};
    margin-bottom: 8px;
  }
  @media (max-width: 580px) {
    width: ${(props) => props.width580 || "328px"};
    height: 100px;
    margin-top: 8px;
  }
`;

export const Element = styled.input`
  direction: rtl;
  outline: none;
  border: none;
  box-sizing: border-box;
  padding: 8px 16px;
  ::placeholder {
    color: #27548c;
    opacity: 1;
  }
  font-family: Peyda;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  text-align: right;
  width: 100%;
  height: 100%;
  resize: none;
  /* overflow: scroll; */
  border-radius: 2px;
`;

export const LabelContainer = styled.div`
  font-family: Yekan-Bakh-Regular;
  direction: rtl;
`;

 export const IconContainer = styled.div`
  width: 10%;
  height: 95%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
 `;


export const Wrapper  = styled.div`
  /* min-height: 100px; */
  overflow: hidden;
  @media (max-width:360px) {
    min-height: 10px;
  }
`